export default "__VITE_ASSET__qZBD7C_Z__"